'use client'

import classNames from 'classnames'
import { useRouter, useSearchParams } from 'next/navigation'
import { Dialog } from 'react-aria-components/Dialog'
import { Modal, ModalOverlay } from 'react-aria-components/Modal'
import { Col, Container, Row } from 'react-bootstrap'

import { Button } from '@/packages/news-ui/basic/button'
import { getPublicEnv } from '@/shared/env'
import { useI18n } from '@/shared/providers'

import styles from './view.module.css'

export function LoginDialog() {
    const searchParams = useSearchParams()

    const runtimeEnv = getPublicEnv()
    const { i18n } = useI18n()

    const modal = searchParams.get('modal')

    const origin = searchParams.get('origin') ?? 'reaction'
    const dialogText =
        origin === 'reaction' ? i18n.TEXT_LOGIN_DIALOG_TEXT_REACTION : i18n.TEXT_LOGIN_DIALOG_TEXT_TRANSLATION

    const router = useRouter()

    const isOpen = Boolean(modal)

    return (
        <ModalOverlay
            isOpen={isOpen}
            onOpenChange={(open) => {
                if (!open) router.back()
            }}
            isDismissable
            className={styles.overlay}
        >
            <Modal className={styles.modal}>
                <Dialog className={styles.content}>
                    <Container className={classNames(styles.header, 'pt-1 px-2')}>
                        <Row>
                            <div className="col col-auto ml-auto">
                                <button onClick={router.back} type="button" className="close" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-12">
                                <h4 className="text-center text-white mb-3">{i18n.TEXT_LOGIN_DIALOG_TITLE}</h4>
                            </div>
                        </Row>
                    </Container>

                    <div className="modal-body show-grid">
                        <Row>
                            <Col>
                                <p className="text-center">{dialogText}</p>
                            </Col>
                        </Row>
                        <Button
                            className="btn-block"
                            onClick={() => {
                                window.location.href = `${runtimeEnv.NEXT_PUBLIC_TAONGA_PORTAL_URL}?action=login`
                            }}
                        >
                            {i18n.BUTTON_LOGIN}
                        </Button>
                        <Button
                            color="info"
                            className="btn-block"
                            onClick={() => {
                                window.location.href = `${runtimeEnv.NEXT_PUBLIC_TAONGA_PORTAL_URL}?action=signup`
                            }}
                        >
                            {i18n.BUTTON_SIGNUP}
                        </Button>
                    </div>
                </Dialog>
            </Modal>
        </ModalOverlay>
    )
}
